var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Events","items":_vm.items,"doc":_vm.doc}},[_c('OrderDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }